import {
  DocumentData,
  Query,
  limit as limitFn,
  orderBy,
  query,
  startAfter,
} from 'firebase/firestore'

import { QueryOptionsType } from 'types/query'

export const formatQueryOptions = <TData,>(
  baseQuery: Query<DocumentData>,
  options: QueryOptionsType<TData>,
) => {
  const { lastVisible, order, limit, orderDirection = 'desc' } = options
  let resultQuery = baseQuery

  // Whatever you order by, you need the startAfter value to be that type
  if (order) {
    resultQuery = query(resultQuery, orderBy(order as string, orderDirection))
    // Must have an order to have a startAfter and lastVisible
    if (lastVisible) {
      resultQuery = query(resultQuery, startAfter(lastVisible))
    }
  }

  if (limit) {
    resultQuery = query(resultQuery, limitFn(limit))
  }

  return resultQuery
}
